export default __webpack_public_path__ + "static/media/corner-ladybug-art.578eee5f.webp";